import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import moment from 'moment';

const ListNormalOnboarding = ({
                                  normalOnboardingListing = null,
                                  getNormalOnBoardingListing = null,
                         }) => {
    const { baseUrl } = useContext(BaseUrl);
    const [listData, setListData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentCarnivalStatus, setCurrentcarnivalStatus] = useState('');
    const [carnivalId, setCarnivalId] = useState('');
    const [changeStatus, setChangeStatus] = useState(false);
    const [projectId, setProjectId] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [pageCount, setPageCount] = useState(0);
    const [filterData, setFilterData] = useState(null);
    const [showFilter, setShowFilter] = useState(false);

    const Headers = [
        'Project No.',
        'Project Name',
        'Society Name',
        'FITKIT Price',
        'RFID Price',
        'Normal Url',
        'QR Link',
        'created_at',
        'updated_at',
        'Action',
    ];

    useEffect(() => {
        if (getNormalOnBoardingListing !== null)
            (async () => {
                setIsLoading(true);
                await getNormalOnBoardingListing();
                setIsLoading(false);
            })();
    }, [getNormalOnBoardingListing]);
    // return true;
    useEffect(() => {
        const tableData = [
             'id',
            'project_id',
            'project_name',
            'society_name',
            'fitkit_price',
            'rfid_price',
            'normal_url',
            'qr_link',
            'created_at',
            'updated_at'
        ];
        const data =
            normalOnboardingListing?.resultSets?.length &&
            normalOnboardingListing.resultSets.map((element) =>
            Object.assign(
              {},
              ...tableData.map((key) => (
                  (key === 'created_at' || key === 'updated_at') ? {[key]: moment(element[key]).format('YYYY-MM-DD')}  : (key !== 'normal_url' && key !== 'qr_link')
                  ? { [key]: element[key] }
                : (key === 'normal_url' && element['normal_url'] != '') ? {[key]: <a href={element[key]} target="_blank">URL</a>} : (key === 'qr_link' && element['qr_link'] != '') ? {[key]: <a href={element[key]} target="_blank">QR</a>} : {[key]: 'Not Available'})),

                (element['status'] === 'Active') ?
                {

                  Action:
                    [
                    // {
                    //   name: 'View Details',
                    //   link: `${baseUrl}/brand-activation/carnival/details`,
                    // },
                    {
                      name: 'Update Details',
                      link: `${baseUrl}/brand-activation/conduct-normal/update`,
                    },
                    // {
                    //   name: 'Change Status',
                    //   rowData: element,
                    // }
                  ]
                }
                :(element['status'] === 'Hold') ?
                {
                  Action:
                    [
                    //     {
                    //   name: 'View Details',
                    //   link: `${baseUrl}/brand-activation/carnival/details`,
                    // },
                    /* {
                      name: 'Update Details',
                      link: `${baseUrl}/brand-activation/carnival/update`,
                    }, */
                    // {
                    //   name: 'Change Status',
                    //   rowData: element,
                    // }
                  ]
                }:(element['status'] === 'Inactive') ?
                {
                  Action:
                    [
                    // {
                    //   name: 'View Details',
                    //   link: `${baseUrl}/brand-activation/carnival/details`,
                    // }
                  ]
                }:{
                  Action:
                    [
                    //     {
                    //   name: 'View Details',
                    //   link: `${baseUrl}/brand-activation/carnival/details`,
                    // },
                    // {
                    //   name: 'Create duplicate',
                    //   link: `${baseUrl}/brand-activation/carnival/create-duplicate`,
                    // }
                  ]
                }
            )
          );

        if (normalOnboardingListing?.resultSets?.length && data) {
          setListData(data);
          setPageCount(Math.ceil(normalOnboardingListing.total / normalOnboardingListing.per_page));
        } else {
          setListData([]);
        }
      }, [normalOnboardingListing, baseUrl]);


    const onPageChange = async (val) => {
        let filter = filterData === null ? null : filterData;
        // setPageNumber(val.selected + 1);
        setIsLoading(true);
        await getNormalOnBoardingListing(filter, val.selected + 1);
        setIsLoading(false);
    };

    const filterToggle = () => {
        setShowFilter(!showFilter);
    };

    const applyFilter = async (filterData) => {
        setIsLoading(true);
        setFilterData(filterData);
        await getNormalOnBoardingListing(filterData, 1);
        setIsLoading(false);
        filterToggle();
    };


    const headerBtns = () => {
        return (
            <Fragment>
                <Link
                    to={{
                        pathname: `${baseUrl}/brand-activation/conduct-normal/add-normal`,
                        query: { noOfCamp: normalOnboardingListing?.resultSets?.length },
                    }}
                    className="btn btn-primary d-md-inline-block"
                >
                    {localization.createNew}
                    <img src={Images?.ArrowRight} alt="" />
                </Link>
                <Button
                    onClick={filterToggle}
                    className="filter-hamburger btn btn-transparent filter-btn-dir filters_direction filters-section"
                >
                    <img src={Images?.Filter} alt="" />
                    <b className="site_filters" style={{width:"max-content"}}>
                        {localization.showFilters}
                    </b>
                </Button>
            </Fragment>
        );
    };

    return (
        <Layout
            title={localization.societyOnboarding}
            Buttons={headerBtns}
            isGoback
            isLoading={isLoading}
            linkFlag
            linkUrl={`${baseUrl}/brand-activation/sites-listing`}
        >
            <TableSection
                data={listData}
                headers={Headers}
                detailList={normalOnboardingListing?.resultSets}
                isId={false}
                pageCount={pageCount}
                onPageChange={onPageChange}
                srNo={normalOnboardingListing?.from}
                setChangeStatus={setChangeStatus}
                setCarnivalId={setCarnivalId}
                setCurrentcarnivalStatus={setCurrentcarnivalStatus}
                setProjectId={setProjectId}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
            />

            <ListFilters
                showFilter={showFilter}
                filterToggle={filterToggle}
                applyFilter={(val) => applyFilter(val)}
                normalOnboardingFilters={true}
                // listFilterData={siteFilters?.site_types ? siteFilters : null}
                // siteFilters
            />
        </Layout>
    );
};

ListNormalOnboarding.propTypes = {
    carnivalList: PropTypes.any,
    getCarnivalList: PropTypes.func,
    match: PropTypes.any,
};

export default ListNormalOnboarding;
